import React, { useState, useEffect } from "react";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import { useSelector } from 'react-redux';
import methodModel from "../../methods/methods";
import { Link, useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/global/layout";
import SelectDropdown from "../../components/common/SelectDropdown";
import statusModel from "../../models/status.model";
import { Tooltip } from "antd";

const AddEdit = () => {
    const { id } = useParams()
    const [form, setform] = useState({ id: '', title: '', status: 'active' })
    const [roles, setRoles] = useState([])
    const history = useNavigate()
    const [submitted, setSubmitted] = useState(false)
    const user = useSelector((state) => state.user);
    const formValidation = [
        { key: 'status', required: true }
    ]

    const handleSubmit = (e) => {
        e.preventDefault()
        setSubmitted(true)
        let invalid = methodModel.getFormError(formValidation, form)
        if (invalid) return
        let method = 'post'
        let url = 'api/skill'
        let value = {
            ...form
        }
        if (value.id) {
            method = 'put'
            url = 'api/skill/update'
        } else {
            value.addedBy=user._id
            delete value.id
        }

        loader(true)
        ApiClient.allApi(url, value, method).then(res => {
            if (res.success) {
                // ToastsStore.success(res.message)
                history("/skills")
            }
            loader(false)
        })
    }

    const getSkillRoles=()=>{
        ApiClient.get('api/skillRole/list',{status:'active'}).then(res=>{
            if(res.success){
                setRoles(res.data)
            }
        })
    }

    useEffect(() => {
        if (id) {
            loader(true)
            ApiClient.get('api/skill/detail', { id }).then(res => {
                if (res.success) {
                    let value = res.data
                    let payload = form

                    Object.keys(payload).map(itm => {
                        payload[itm] = value[itm]
                    })
                    if(payload.skillRole?._id){
                        payload.skillRole=payload.skillRole?._id||''
                    }
                   
                    payload.id=id
                    setform({
                        ...payload
                    })
                }
                loader(false)
            })
        }
        getSkillRoles()
    }, [id])

    return <>
        <Layout>
            <form onSubmit={handleSubmit}>
                <div className="pprofile1 shadow-lg">


                    <div className='flex items-center mb-8'>
                        <Tooltip placement="top" title="Back">

                            <Link to="/skills" className="!px-4  py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all  mr-3"><i className='fa fa-angle-left text-lg'></i></Link>
                        </Tooltip>
                        <div>
                            <h3 className="text-2xl font-semibold text-[#111827]">
                                {form && form.id ? 'Edit' : 'Add'}  Skills
                            </h3>
                            <p class="text-sm font-normal text-[#525252]">Here you can see all about your Skills</p>
                        </div>
                    </div>



                    <h3 className="ViewUser mb-3"></h3>
                    <div className="grid grid-cols-2">
                        <div className="col-md-6 mb-3">
                            <label>Title<span className="star">*</span></label>
                            <input
                                type="text"
                                className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                                value={form.title}
                                onChange={e => setform({ ...form, title: e.target.value })}
                                required
                            />
                        </div>

                        {/* <div className="col-md-6 mb-3">
                            <label>Role<span className="star">*</span></label>
                            <div className="custom_dropdown">
                                <SelectDropdown
                                    id="statusDropdown"
                                    displayValue="name"
                                    intialValue={form.skillRole}
                                    result={e => { setform({ ...form, skillRole: e.value }) }}
                                    options={roles}
                                    theme="search"
                                />
                                {submitted && !form.skillRole ? <div className="text-danger">Role is Required</div> : <></>}
                            </div>
                        </div> */}

                        <div className="col-md-6 mb-3">
                            <label>Status<span className="star">*</span></label>
                            <div className="custom_dropdown">
                                <SelectDropdown
                                    id="statusDropdown"
                                    displayValue="name"
                                    intialValue={form.status}
                                    result={e => { setform({ ...form, status: e.value }) }}
                                    options={statusModel.list}
                                />
                                {submitted && !form.status ? <div className="text-danger">Status is Required</div> : <></>}
                            </div>
                        </div>
                    </div>
                    <div className="text-right">

                        <button type="submit" className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:opacity-80 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">Save</button>
                    </div>
                </div>


            </form>
        </Layout>
    </>
}

export default AddEdit